import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { View } from 'react-native';
import { useOrganizationId } from '../../../../../hooks/api/useOrganization';
import { OrganizationClientRecordNoteDestination } from '../../../../shared/Notes/utils/types';

export type AddClientRecordNoteOwnProps = {};

export type AddClientRecordNoteProps = AddClientRecordNoteOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'add-client-record-note'>;
};

const AddClientRecordNoteScreen: React.FC<AddClientRecordNoteProps> = (props) => {
    const organizationId = useOrganizationId();
    const goBack = useGoBack();
    const noteDestination = useMemo<OrganizationClientRecordNoteDestination>(
        () => ({
            entityType: 'organization-client-record',
            organizationId,
            organizationClientRecordId: props.route.params.clientRecordId,
        }),
        [organizationId, props.route.params.clientRecordId],
    );
    const { isCreatingNote, noteEditorProps, key } = useEditNote({
        noteDestination,
        onCreationSuccess: () => {
            goBack();
        },
    });
    return (
        <View style={{ width: '100%', height: '100%' }}>
            <NotesEditor
                key={key}
                source="profiles.add-client-record-note-route"
                onCancel={() => goBack()}
                isDisabled={isCreatingNote}
                noteDestination={noteDestination}
                disableRecording
                {...noteEditorProps}
            />
        </View>
    );
};

export default React.memo(AddClientRecordNoteScreen);
